// @ts-nocheck: converted from JS

import { Panel, Tab, Tabs } from '@/components/UI/Tabs';
import ApprovedTable from './ApprovedTable';
import PendingTable from './PendingTable';
import Header from '@/components/UI/Header';

const Approvals = () => {
  return (
    <>
      <div className="ph4 pb3">
        <Header mainHeaderText="Reviews" />
      </div>
      <Tabs>
        <div className="bb b--moon-gray mh3 mh4-l">
          <Tab className="f4">Pending</Tab>
          <Tab className="f4">Completed</Tab>
        </div>
        <Panel>
          <PendingTable />
        </Panel>
        <Panel>
          <ApprovedTable />
        </Panel>
      </Tabs>
    </>
  );
};

export default Approvals;
